import {AbstractFilter} from './abstract-filter';
import {SelectItem} from 'primeng/api';

export class HoursAndMinutesFilter extends AbstractFilter {

  public getValueFromChange(event, param) {
      return event;
  }
}
